// extracted by mini-css-extract-plugin
module.exports = {"gpt-ad":"styles_gpt-ad__BVAfH"};